import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIconShape20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconIconShape20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4.56 3.5h10.88l-2.474 2.474A4.98 4.98 0 0 0 10 5c-1.11 0-2.136.362-2.965.974zM3.5 4.56v10.88l2.474-2.474A4.98 4.98 0 0 1 5 10c0-1.11.362-2.136.974-2.965zm3.552 3.553A3.5 3.5 0 0 0 6.5 10c0 .695.203 1.343.552 1.887L8.939 10zM10 11.06l-1.887 1.887c.544.35 1.192.552 1.887.552s1.343-.203 1.887-.552zm2.948.826L11.061 10l1.887-1.887c.35.544.552 1.192.552 1.887s-.203 1.343-.552 1.887m.018 2.14A4.98 4.98 0 0 1 10 15a4.98 4.98 0 0 1-2.965-.974L4.56 16.5h10.878zm3.534 1.412-2.474-2.474c.612-.83.974-1.855.974-2.965s-.362-2.136-.974-2.965L16.5 4.56zM10 8.94 8.113 7.052A3.5 3.5 0 0 1 10 6.5c.695 0 1.343.203 1.887.552zM2 4.5A2.5 2.5 0 0 1 4.5 2h11A2.5 2.5 0 0 1 18 4.5v11a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 2 15.5z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIconShape20);
